import { Button } from "@/shared/components/ui/button";
import {
    Dialog,
    DialogBody,
    DialogContainer,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/shared/components/ui/dialog";

interface BulkApprovalDialogProps {
    onOpenChange: (open: boolean) => void;
    operation: "start" | "stop";
    onConfirm: () => void;
}

export function BulkApprovalDialog({ onOpenChange, operation, onConfirm }: Readonly<BulkApprovalDialogProps>) {
    const config = {
        start: {
            title: "Vestigingen goedgekeurd in AXI",
            description: "Zijn alle vestigingen goedgekeurd in AXI? Met deze actie zet je alle AXI vestigingen op Actief.",
            action: "Vestigingen activeren",
            variant: "primary" as const,
            destructive: false,
        },
        stop: {
            title: "Vestigingen gestopt in AXI",
            description: "Zijn alle vestigingen gestopt in AXI? Met deze actie zet je alle AXI vestigingen op Gestopt.",
            action: "Vestigingen stoppen",
            variant: "primary" as const,
            destructive: true,
        },
    };

    return (
        <Dialog open={true} onOpenChange={onOpenChange}>
            <DialogContainer>
                <DialogHeader>
                    <DialogTitle>{config[operation].title}</DialogTitle>
                </DialogHeader>
                <DialogBody>
                    <DialogDescription>{config[operation].description}</DialogDescription>
                </DialogBody>

                <DialogFooter>
                    <Button variant="tertiary" onClick={() => onOpenChange(false)}>
                        Annuleren
                    </Button>
                    <Button variant={config[operation].variant} destructive={config[operation].destructive} onClick={onConfirm}>
                        {config[operation].action}
                    </Button>
                </DialogFooter>
            </DialogContainer>
        </Dialog>
    );
}
